import React, { useState, useEffect } from "react";
import styles from "./Components/CSS/BottomArea.module.css";
import { useNavigate } from "react-router-dom";
import { usePopularBlogs } from "../hooks/useBlogs";
import Loading from '../common/HousGlass Loader/Loading';

const BlogSection = () => {
  const navigate = useNavigate();
  const { blogs, isLoading } = usePopularBlogs(5);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [loading, setLoading] = useState(false);

  // Set the first blog as selected once data is loaded
  useEffect(() => {
    if (blogs && blogs.length > 0 && !selectedBlog) {
      setSelectedBlog(blogs[0]);
    }
  }, [blogs, selectedBlog]);

  const handleBlogClick = (blog) => {
    setLoading(true);
    setTimeout(() => {
      setSelectedBlog(blog);
      setLoading(false);
    }, 100); // Simulated delay for better UX
  };

  // Show loader while initial data is loading
  if (isLoading || !selectedBlog) {
    return <div className={styles.container}><Loading/></div>;
  }

  return (
    <div className={styles.container}>
      {/* Left: Main Blog Section */}
      <div className={styles.mainBlog}>
        {loading ? (
          <p className={styles.loading}><Loading/></p>
        ) : (
          <>
            <img 
              src={selectedBlog.featuredImage} 
              alt={selectedBlog.title} 
              className={styles.mainImage} 
            />
            <h2 className={styles.title}>{selectedBlog.title}</h2>
            <div className={styles.meta}>
              {selectedBlog.author && (
                <>
                  <span>{selectedBlog.author.name}</span>
                  <span>•</span>
                </>
              )}
              <span>{new Date(selectedBlog.createdAt).toLocaleDateString()}</span>
            </div>
            <p className={styles.content}>
              {selectedBlog.content ? 
                selectedBlog.content.replace(/<[^>]*>/g, '').substring(0, 200) + '...' : 
                'No content available'}
            </p>
            <span 
              onClick={() => navigate(`/blog/${selectedBlog.slug}`)} 
              className={styles.viewPost}
            >
              View post
            </span>
          </>
        )}
      </div>

      {/* Right: Top Blogs */}
      <div className={styles.sideBlogs}>
        {blogs.map((blog) => (
          <button 
            key={blog.id} 
            className={`${styles.sideBlog} ${selectedBlog.id === blog.id ? styles.activeBlog : ''}`}
            onClick={() => handleBlogClick(blog)}
          >
            <img 
              src={blog.featuredImage} 
              alt={blog.title} 
              className={styles.sideImage} 
            />
            <div>
              <h3 className={styles.sideTitle}>{blog.title}</h3>
              <p className={styles.sideDate}>
                {new Date(blog.createdAt).toLocaleDateString()}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BlogSection;